import React from 'react'
import ProductLocationMain from './ProductLocationMain'


const ProductLocationLayout = () => {
  return <ProductLocationMain />
}

export default ProductLocationLayout
